/**
 * Allows for interception HTTP requests and responses
 */
export type HttpInterceptor<T> = (url: string, response: T) => Promise<T>;

export class Interceptors {
	constructor(
    public request: HttpInterceptor<RequestInit>[] = [],
    public response: HttpInterceptor<Response>[] = []
	) {
	}
}